import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CartProductDelete from '../CartProduct/CartProductDelete/CartProductDelete';
import CartProductPrice from '../CartProduct/CartProductPrice/CartProductPrice';
import CartProductWrapper from '../CartProductWrapper/CartProductWrapper';
import Loading from 'components/Common/Loading/Loading';
import useProductInfos from 'hooks/useProductInfos';
import { cartContext } from 'contexts/cartContext';
import { CartSpecialOffer } from 'types/Cart';

import styles from './CartSpecialOffers.module.scss';

export default function CartSelectedSpecialOffer({
  specialOffer,
}: {
  specialOffer: CartSpecialOffer;
}): JSX.Element {
  const { t } = useTranslation();
  const { deleteProduct } = useContext(cartContext);
  const [isLoading, setIsLoading] = useState(false);
  const { sku, sizeLabel, price, choice, reference } = specialOffer.products[0];
  const { productInfos } = useProductInfos(sku, reference, sizeLabel);

  if (!productInfos) {
    return <></>;
  }

  function handleDelete() {
    setIsLoading(true);
    deleteProduct(
      sku,
      reference,
      sizeLabel,
      'so',
      sku + '|' + specialOffer.attributes.codeAm
    ).finally(() => setIsLoading(false));
  }

  return (
    <>
      <CartProductWrapper
        classes={{ title: styles.title }}
        image={productInfos.front_view}
        title={t('LABEL_YOUR_SPECIAL_OFFER')}
      >
        <p className={styles.model}>{productInfos.name}</p>
        <p>
          <b>{t('LABEL_TWO_POINTS', { label: t('LABEL_CHOICES') })}</b>
          {choice}
        </p>
        <p>
          <b>{t('LABEL_TWO_POINTS', { label: t('LABEL_QUANTITY') })}</b>1
        </p>
        <div className={styles.delete}>
          <CartProductDelete
            modelName={productInfos.name}
            onDelete={handleDelete}
          />
        </div>
        <div className={styles.price}>
          <CartProductPrice price={price} />
        </div>
      </CartProductWrapper>
      {isLoading && <Loading loading />}
    </>
  );
}
